export default {
    Photos: "Fotoğraflar",
    TAKE_PHOTO_DESCRIPTION: "Fotoğraf çekmek kamera simgesine tıklayın, iptal etmek için çarpıya tıklayın.",
    SelectDocumentType: "Belge Tipini Seçin",
    SelectDocumentFace: "Belge Yönünü Seçin",

    ErrorSendingPhoto: "Fotoğraf Gönderilirken Hata Oluştu",
    PhotoSentSuccessfully: "Fotoğraf Başarıyla Gönderildi",

    AreYouSureToDelete: "Silmek istediğinizden emin misiniz?",
    YouWontBeAbleToRevertThis: "Bu aksiyon geri alınamaz.",
    Yes: "Evet",
    Cancel: "İptal",
}